



























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import NavbarEventsMenu from '@/views/layout/navigation/navbar-events-menu.vue';
@Component({
  components: {
    NavbarEventsMenu
  }
})
export default class NavbarEvents extends Vue  {
  @Prop()
  changePlanClick;

  menu: boolean = false;

  @Prop({ default: '' })
  contentClass: string;

  @Prop()
  nudgeLeft: number;

  @Prop()
  nudgeRight: number;

  @Prop()
  nudgeTop: number;

  @Prop()
  nudgeBottom: number;

  @Prop()
  offsetX: boolean;

  @Prop()
  offsetY: boolean;

  @Prop()
  closeMenu: any;
}
